var map = {
	"./best-app-development-tool.md": [
		97,
		3
	],
	"./common-misconceptions-about-payment.md": [
		98,
		4
	],
	"./things-to-know-about-startup-business.md": [
		99,
		5
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 94;
module.exports = webpackAsyncContext;